<template>
  <div class="invite-template internal-section">
    <div class="columns is-flex-column">

      <div class="column is-fullwidth is-paddingless">
        <p>Use Hellopeter review invites to drive Google reviews so you can build a consistent online reputation
          and review profile.
          By connecting your Google My Business account you can manage your review invite sending from one
          platform and collect reviews on multiple platforms.</p>
      </div>

      <div class="google-connect-box">
        <div :class="{'img': true, 'disabled-img-box': !isPaidSubscription}">
          <div>
            <img srcset="/static/img/social/gmb/Image-403@3x.png,
                        /static/img/social/gmb/Image-403@2x.png 2x,
                        /static/img/social/gmb/Image-403@3x.png 3x"
                 alt="Google My Business"
                 class="gmb-logo"
            />

            <div class="upgrade-popup" @click="renewOrUpgrade()" v-if="!this.isPaidSubscription">
              <img src="/static/img/lock-icon.svg"/>
              <div class="msg">Upgrade to gain instant access</div>
            </div>

          </div>
        </div>
        <div class="text-row">
          <strong>Google My Business</strong>
          <a v-if="isPaidSubscription" :class="{'button': true, 'connect-btn': true}" class="solid-btn"
             data-track="Google Reviews - Connect Google Account"
             @click="openModal()">CONNECT</a>
          <a v-else :class="{'button': true, 'connect-btn': true}" class="solid-btn solid-btn--disabled"
             data-track="Google Reviews - Connect Google Account"
             @click="renewOrUpgrade()">CONNECT</a>
        </div>
      </div>

      <div v-if="showGMBTokenError" class="location-not-verified location-invalid-token columns">
        <div class="column is-1 left">!</div>
        <div class="column is-11 right">
          Hellopeter is not authorised to manage your Google Business Listing.
          Please re-connect and ensure you select the check box that gives Hellopeter the required
          permissions.
        </div>
      </div>

      <div v-else-if="showGMBAccessError" class="location-not-verified location-invalid-token columns">
        <div class="column is-1 left">!</div>
        <div class="column is-11 right">
          You no longer have permission to manage the selected location for this Google My Business account.
          Please select a location with the required permissions.
        </div>
      </div>

      <div v-else-if="0" class="location-not-verified columns">
        <div class="column is-1 left">!</div>
        <div class="column is-11 right">
          To use this feature your Google My Business location needs to be verified.
          To find out how to verify your location click
          <a href="https://support.google.com/business/answer/7107242?hl=en"
             target="_blank"
             data-track="Google Reviews - Setup - Help - how to verify your location">here</a>.
        </div>
      </div>


    </div>

    <GMBModal
      :show=toggleModal
      :page=page
      @closeModal="toggleModal=false"
      @updateFinished="$emit('updateFinished')"
    ></GMBModal>
  </div>
</template>
<script>
/* eslint-disable indent,no-new,no-undef,valid-jsdoc */
import GMBModal from './../../../components/GMBModal.vue'
import {mapGetters, mapState} from 'vuex'
import {IS_GOOGLE_CONNECTED} from '@/store/getter.types'

export default {
  name: 'GMBSetup',
  components: {
    GMBModal
  },
  data () {
    return {
      userInfo: JSON.parse(localStorage.getItem('billingDetails')),
      businessSlug: localStorage.getItem('org_slug'),
      toggleModal: false,
      page: ''
    }
  },
  props: {
    isPaidSubscription: Boolean,
    showGMBTokenError: {
      type: Boolean,
      default: false
    },
    showGMBAccessError: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      gmbSetup: state => state.gmb.gmbSetup
    }),

    ...mapGetters({
      isGoogleConnected: `gmb/${IS_GOOGLE_CONNECTED}`
    })
  },
  created () {
    if (!this.isGoogleConnected && ('id' in this.gmbSetup) && this.$route.query.setup === 'true') {
      this.toggleModal = true
      this.page = 'locationSetup'
    }
  },
  methods: {
    openModal (tabName) {
      var currentUrl = this.$router.currentRoute
      if (currentUrl.path.indexOf('onsite-widgets/details') > -1) {
        window.localStorage.setItem('widget_redirect_url', currentUrl.path)
      } else {
        window.localStorage.removeItem('widget_redirect_url')
      }
      if (this.isPaidSubscription) {
        this.tabName = tabName
        this.toggleModal = !this.toggleModal
      }
    },
    /**
     *  Redirect to renew or upgrade page
     *  @returns {void}
     */
    renewOrUpgrade () {
      this.$router.push('/billing/edit-plan/g1/monthly')
    }
  }
}
</script>
<style scoped>
.invite-template {
  margin-top: 28px;
}

.is-flex-column {
  flex-direction: column;
}

.google-connect-box {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.16);
  border: solid 1px rgba(216, 216, 216, 0.32);
  width: 278px;
  margin-top: 10px;
}

.google-connect-box .img {
  background: url("/static/img/review-invites/mask-group-267.png");
  width: 278px;
  height: 140px;
}

.google-connect-box .img > div {
  padding-top: 38px;
  width: 124px;
  margin: 0 auto;
}

.google-connect-box strong {
  font-size: 12px;
  line-height: 20px;
  display: block;
  text-align: center;
  margin: 17px 0;
}

.google-connect-box .text-row {
  text-align: center;
}

.google-connect-box .connect-btn {
  font-size: 12px;
  width: 130px;
  margin: 0 0 25px;
}

.google-connect-box .disabled-connect {
  background: #cdcbcb;
  border-color: #cdcbcb;
}

.google-connect-box .disabled-img-box {
  position: relative;
  text-align: center;
}

.google-connect-box .disabled-img-box:hover .gmb-logo {
  opacity: 0.25;
}

.google-connect-box .img span {
  display: none;
}

.google-connect-box .lock-wrapper {
  display: none;
}

.google-connect-box .disabled-img-box span {
  display: block;
  font-size: 14px;
  line-height: 19px;
  color: #fff;
  position: absolute;
  top: 72%;
  left: 0;
  width: 100%;
}

.google-connect-box .disabled-img-box .lock-wrapper {
  position: absolute;
  top: 25%;
  display: block;
  width: 100%;
  left: 0;
}

.google-connect-box .disabled-img-box .gmb-lock {
  width: 100%;
  max-width: 21px;
  height: auto;
}

p {
  font-size: 12px;
}

.invite-template {
  min-width: 400px;
}

.location-not-verified {
  border: 1px solid #E4862C;
  color: #E4862C;
  width: 522px;
  font-size: 12px;
  line-height: 17px;
  margin: 15px 0;
}

.location-not-verified .left {
  display: inline-block;
  border-right: 1px solid #E4862C;
  text-align: center;
  font-size: 16px;
  padding-top: 20px;
  font-weight: bold;
}

.location-not-verified .right a {
  text-decoration: underline;
  color: #30aae1;
}

.location-invalid-token {
  border: 1px solid red;
  color: red;
}

.location-invalid-token .left {
  border-right: 1px solid red;
}

.upgrade-popup {
  position: absolute;
  top: 0px;
  left: 0px;
  background: rgba(0, 0, 0, 0.51);
  height: 100%;
  width: 100%;
  z-index: 999;
  opacity: 1;
  display: none;
  color: #ffffff;
  cursor: pointer;
}

.upgrade-popup img {
  position: relative;
  top: -15px;
  height: 27px;
}

.upgrade-popup .msg {
  font-size: 14px;
}

.disabled-img-box:hover .upgrade-popup {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/pages/collect-reviews/gmb/GMBSetup.vue